import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetPortfolioById = function () {
    return useApiCall(function (signal, id) { return api.portfolio.apiPortfolioDataGetIdGet(id, { signal: signal }); }, null, true, []);
};
